export interface GetLocationByIdAndEntityTypeRequest {
  id?: string;
  entityType?: number;
}
